import JobSingleList from './JobSingleList';

export default JobSingleList;

